<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [title]="'Getting Started'"
      [class]="extraClass"
      [canGoBack]="true"
      [customBackAction]="handleMobileBack" />
  }
</ng-template>

<ng-container
  *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <div class="getting-started-wrapper"
       [class.gs-is-mobile]="!windowService?.isDesktopRes"
       [class.gs-no-properties]="!addresses?.length">

    <div class="gs-star-field">
      @for (star of stars; track $index) {
        <div class="gs-star" [style]="star.style"></div>
      }
    </div>

    <div class="gs-header">
      <div>
        @if (windowService?.isDesktopRes) {
          <div class="gs-desktop-header-row" (click)="goBack()">
            <img src="assets/img/white-back-arrow.svg" class="gs-desktop-back-icon" alt="" />
            <h1 class="gs-title">Getting Started</h1>
          </div>
        }
        @if (addressesLoaded && addresses.length > 0) {
          <div class="gs-address-select-row">
            <form [formGroup]="addressSelectForm" novalidate>
              <tidy-header-select
                [items]="addressSelectItems"
                [form]="addressSelectForm.controls.selectedAddress"
                formControlName="selectedAddress"
                (optionChange)="onAddressSelectChange($event)"
                [icon]="'assets/svg/home.svg'" />
            </form>
            <tidy-small-button
              [iconOnly]="false"
              [text]="'Add Property'"
              [image]="'assets/img/add-white.svg'"
              (buttonClick)="goToAddProperty()"
              class="gs-add-property-small-btn" />
          </div>
        }
        @if (!addressesLoaded) {
          <div class="gs-address-list-section">
            <tidy-loader [show]="true" />
          </div>
        }
        @if (addresses.length === 0 && addressesLoaded) {
          <div class="gs-address-list-section">
            <tidy-alert>
              <tidy-row>
                <tidy-text [body]="'No Properties Added'" />
              </tidy-row>
            </tidy-alert>
            <div class="gs-add-property-row">
              <div class="gs-add-property-btn" (click)="goToAddProperty()">
                <img src="assets/svg/add-outline.svg" class="gs-add-property-icon" alt="" />
                <span class="gs-add-property-label">Add Property</span>
              </div>
            </div>
          </div>
        }
      </div>

      <!-- <div class="gs-concierge-wrapper">
        <div class="gs-concierge-btn" (click)="toggleConciergeDropdown()">
          <img src="assets/svg/person-circle-outline.svg" class="gs-concierge-icon" alt="" />
          <span class="gs-concierge-label">Concierge</span>
        </div>

        @if (conciergeDropdownOpen) {
          <div class="gs-concierge-dropdown">
            <div class="gs-concierge-profile">
              <div class="gs-concierge-avatar">
                <img src="assets/svg/person-circle-outline.svg" class="gs-concierge-avatar-img" alt="" />
              </div>
              <span class="gs-concierge-name">Swahib</span>
            </div>

            <div class="gs-concierge-info-row" (click)="openConciergeInfo()">
              <span class="gs-concierge-info-text">What can Swahib do for you?</span>
              <img src="assets/svg/information-circle-outline.svg" class="gs-concierge-info-icon" alt="" />
            </div>

            <div class="gs-concierge-action" (click)="scheduleConciergeCall()">
              <span class="gs-concierge-action-text">Schedule Call</span>
              <img src="assets/svg/calendar-outline.svg" class="gs-concierge-action-icon" alt="" />
            </div>

            <div class="gs-concierge-divider"></div>

            <div class="gs-concierge-footer">
              <span class="gs-concierge-footer-text">For additional resources, visit </span>
              <span class="gs-concierge-footer-link">Help Center</span>
            </div>
          </div>
        }
      </div> -->
    </div>

    @if (viewState === 'select_type') {
      <div class="gs-type-selection">
        <div class="gs-question-heading-row">
          <h2 class="gs-question-title">What kind of property is {{selectedAddressName}}?</h2>
        </div>
        <div class="gs-type-cards">
          <div class="gs-type-card" (click)="selectRentalType('short_term')">
            <div class="gs-type-card-inner">
              <div class="gs-type-icon-box">
                <img src="assets/svg/calendar-outline.svg" class="gs-type-icon" alt="" />
              </div>
              <div class="gs-type-card-text">
                <span class="gs-type-card-title">Short Term Rental</span>
                <span class="gs-type-card-subtitle">Nightly or weekly stays.</span>
              </div>
            </div>
          </div>
          <div class="gs-type-card" (click)="selectRentalType('long_term')">
            <div class="gs-type-card-inner">
              <div class="gs-type-icon-box">
                <img src="assets/svg/business-outline.svg" class="gs-type-icon" alt="" />
              </div>
              <div class="gs-type-card-text">
                <span class="gs-type-card-title">Long Term Rental</span>
                <span class="gs-type-card-subtitle">Traditional annual leases.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    @if (viewState === 'has_listing_question') {
      <div class="gs-type-selection">
        <div class="gs-question-heading-row">
          <div class="gs-question-back" (click)="goBackFromListingQuestion()">
            <img src="assets/img/white-back-arrow.svg" class="gs-question-back-icon" alt="" />
          </div>
          <h2 class="gs-question-title">Is this property listed?</h2>
        </div>
        <div class="gs-type-cards">
          <div class="gs-type-card" (click)="selectHasListing('yes')">
            <div class="gs-type-card-inner">
              <div class="gs-type-icon-box">
                <img src="assets/svg/checkmark-circle-outline.svg" class="gs-type-icon" alt="" />
              </div>
              <div class="gs-type-card-text">
                <span class="gs-type-card-title">Yes</span>
                <span class="gs-type-card-subtitle">I have an active listing on Airbnb, VRBO, or another platform.</span>
              </div>
            </div>
          </div>
          <div class="gs-type-card" (click)="selectHasListing('no')">
            <div class="gs-type-card-inner">
              <div class="gs-type-icon-box">
                <img src="assets/svg/close-circle-outline.svg" class="gs-type-icon" alt="" />
              </div>
              <div class="gs-type-card-text">
                <span class="gs-type-card-title">No</span>
                <span class="gs-type-card-subtitle">I don't have a listing yet.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    @if (viewState === 'no_listing_schedule_call') {
      <div class="gs-type-selection gs-schedule-call-view">
        <div class="gs-schedule-call-header">
          <div class="gs-question-heading-row">
            <div class="gs-question-back" (click)="goBackFromNoListing()">
              <img src="assets/img/white-back-arrow.svg" class="gs-question-back-icon" alt="" />
            </div>
            <h2 class="gs-question-title">Schedule a Call</h2>
          </div>
          <p class="gs-waitlist-desc">Please schedule a call with our concierge to proceed.</p>
        </div>
        <div
          #inlineCalendlyContainer
          class="calendly-inline-widget gs-calendly-embed"
          data-url="https://calendly.com/thomaztidy/tidy-onboarding">
        </div>
      </div>
    }

    @if (viewState === 'call_scheduled') {
      <div class="gs-type-selection">
        <div class="gs-call-scheduled-card">
          <img src="assets/svg/checkmark-circle-outline.svg" class="gs-call-scheduled-icon" alt="" />
          <h2 class="gs-question-title">Call Scheduled</h2>
          <p class="gs-waitlist-desc">Your setup call is scheduled. Our concierge will walk you through getting your property set up.</p>
        </div>
      </div>
    }

    @if (viewState === 'short_term') {
      @if (windowService?.isDesktopRes) {
        <div class="gs-scene" #sceneContainer>

          <svg class="gs-connections" [attr.viewBox]="svgViewBox" preserveAspectRatio="xMidYMid meet">
            @for (node of nodes; track node.id) {
              <path
                [attr.d]="node.svgPath"
                class="gs-connection-line"
                [class.visible]="node.visible"
                [class.active]="node.hovered"
                [class.completed]="node.completed" />
            }
          </svg>

          <div class="gs-center-btn" [class.loaded]="introStarted" [class.gs-live]="isLive" [style]="centerBtnStyle" (click)="!isLive && goLive()">
            <div class="gs-shimmer-sweep"></div>
            <div class="gs-center-content">
              <img src="assets/svg/rocket-outline.svg" class="gs-rocket-icon" alt="" />
              <span class="gs-center-label">{{isLive ? 'Live' : 'Go Live'}}</span>
            </div>
          </div>

          @for (node of nodes; track node.id) {
            <div
              class="gs-node-card"
              [class.gs-node-visible]="node.visible"
              [class.gs-node-floating]="node.floating"
              [class.gs-node-completed]="node.completed"
              [style.left.px]="node.leftPx"
              [style.top.px]="node.topPx"
              (mouseenter)="node.hovered = true"
              (mouseleave)="node.hovered = false"
              (click)="onNodeClick(node)">
              <div class="gs-node-shimmer-clip">
                <div class="gs-node-shimmer-sweep"></div>
              </div>
              <div class="gs-node-inner">
                <div class="gs-node-icon-box">
                  <img [src]="node.icon" class="gs-node-icon" alt="" />
                </div>
                <span class="gs-node-title">{{node.title}}</span>
                <div class="gs-node-dot"></div>
              </div>
              @if (node.id === 'listings' && showStartHere) {
                <div class="gs-start-here gs-start-here-desktop"
                     [class.gs-start-here-below]="startHereBelow">
                  <span class="gs-start-here-label">Start Here</span>
                  <div class="gs-start-here-arrow"></div>
                </div>
              }
            </div>
          }
        </div>
      }

      @if (!windowService?.isDesktopRes) {
        <div class="gs-mobile-timeline">
          <div class="gs-timeline-inner">
            <div class="gs-timeline-line"></div>

            @for (node of mobileNodes; track node.id) {
              <div
                class="gs-timeline-step"
                [class.gs-node-visible]="node.visible"
                [class.gs-node-floating]="node.floating">
                <div class="gs-timeline-connector">
                  <div
                    class="gs-timeline-dot"
                    [class.completed]="node.completed">
                  </div>
                </div>
                <div
                  class="gs-timeline-card"
                  [class.gs-node-completed]="node.completed"
                  (click)="onNodeClick(node)">
                  <div class="gs-node-shimmer-clip">
                    <div class="gs-node-shimmer-sweep"></div>
                  </div>
                  <div class="gs-node-inner">
                    <div class="gs-node-icon-box">
                      <img [src]="node.icon" class="gs-node-icon" alt="" />
                    </div>
                    <span class="gs-node-title">{{node.title}}</span>
                    <div class="gs-node-dot"></div>
                  </div>
                </div>
              </div>
            }

            <div
              class="gs-timeline-golive"
              [class.loaded]="introStarted">
              <div class="gs-timeline-connector">
                <div class="gs-timeline-dot final"></div>
              </div>
              <div class="gs-mobile-golive-btn" [class.gs-live]="isLive" (click)="!isLive && goLive()">
                <div class="gs-shimmer-sweep"></div>
                <div class="gs-node-inner">
                  <img src="assets/svg/rocket-outline.svg" class="gs-mobile-golive-icon" alt="" />
                  <span class="gs-mobile-golive-label">{{isLive ? 'Live' : 'Go Live'}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      @for (particle of particles; track $index) {
        <div class="gs-particle" [style]="particle.style"></div>
      }
    }

    @if (viewState === 'long_term') {
      <div class="gs-waitlist">
        <div class="gs-question-heading-row">
          <div class="gs-question-back" (click)="viewState = 'select_type'">
            <img src="assets/img/white-back-arrow.svg" class="gs-question-back-icon" alt="" />
          </div>
          <h2 class="gs-question-title">Join Waitlist</h2>
        </div>
        <p class="gs-waitlist-desc">Long term rental management is coming soon. Join our waitlist to be the first to know when it's available.</p>
        <button class="gs-waitlist-btn" (click)="joinWaitlist()">Join Waitlist</button>
      </div>
    }

    @if (viewState === 'waitlist_joined') {
      <div class="gs-waitlist">
        <div class="gs-question-heading-row">
          <div class="gs-question-back" (click)="leaveWaitlist()">
            <img src="assets/img/white-back-arrow.svg" class="gs-question-back-icon" alt="" />
          </div>
          <h2 class="gs-question-title">Waitlist Joined</h2>
        </div>
        <p class="gs-waitlist-desc">Long term rental management is coming soon. Join our waitlist to be the first to know when it's available.</p>
      </div>
    }

    @if (viewState === 'short_term' || viewState === 'long_term') {
    <div class="gs-trust-strip" [class.gs-trust-strip-visible]="trustStripVisible">
      <div class="gs-trust-strip-inner">
        <div class="gs-trust-item gs-trust-google">
          <img src="assets/img/google.svg" alt="Google" class="gs-trust-logo" />
          <div class="gs-trust-rating">
            <span class="gs-rating-value">4.7</span>
            <span class="gs-rating-stars">★★★★★</span>
          </div>
        </div>
        <div class="gs-trust-divider"></div>
        <div class="gs-trust-item gs-trust-stat">
          <span class="gs-stat-value">10K+</span>
          <span class="gs-stat-label">{{ 'property managers' | translate }}</span>
        </div>
        <div class="gs-trust-divider"></div>
        <div class="gs-trust-item gs-trust-logos-carousel">
          <span class="gs-logos-label">{{ 'Trusted by' | translate }}</span>
          <div class="gs-logos-track">
            <div class="gs-logos-scroll">
              <img src="assets/img/customerlogos/arklogo.png" alt="Ark" class="gs-customer-logo" />
              <img src="assets/img/customerlogos/zeus.svg" alt="Zeus" class="gs-customer-logo" />
              <img src="assets/img/customerlogos/compass.svg" alt="Compass" class="gs-customer-logo" />
              <img src="assets/img/customerlogos/darker.png" alt="Darker" class="gs-customer-logo" />
              <img src="assets/img/customerlogos/luxurylifestyle.png" alt="Luxury Lifestyle" class="gs-customer-logo" />
              <img src="assets/img/customerlogos/stroyke.png" alt="Stroyke" class="gs-customer-logo" />
              <img src="assets/img/customerlogos/kuhr.png" alt="Kuhr" class="gs-customer-logo" />
              <img src="assets/img/customerlogos/boutiq.png" alt="Boutiq" class="gs-customer-logo" />
              <img src="assets/img/customerlogos/hemlane.svg" alt="Hemlane" class="gs-customer-logo" />
              <img src="assets/img/customerlogos/amenify.svg" alt="Amenify" class="gs-customer-logo" />
              <img src="assets/img/customerlogos/arklogo.png" alt="Ark" class="gs-customer-logo" />
              <img src="assets/img/customerlogos/zeus.svg" alt="Zeus" class="gs-customer-logo" />
              <img src="assets/img/customerlogos/compass.svg" alt="Compass" class="gs-customer-logo" />
              <img src="assets/img/customerlogos/darker.png" alt="Darker" class="gs-customer-logo" />
              <img src="assets/img/customerlogos/luxurylifestyle.png" alt="Luxury Lifestyle" class="gs-customer-logo" />
              <img src="assets/img/customerlogos/stroyke.png" alt="Stroyke" class="gs-customer-logo" />
              <img src="assets/img/customerlogos/kuhr.png" alt="Kuhr" class="gs-customer-logo" />
              <img src="assets/img/customerlogos/boutiq.png" alt="Boutiq" class="gs-customer-logo" />
              <img src="assets/img/customerlogos/hemlane.svg" alt="Hemlane" class="gs-customer-logo" />
              <img src="assets/img/customerlogos/amenify.svg" alt="Amenify" class="gs-customer-logo" />
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>

  <tidy-popup-overlay
    [isOpen]="conciergeInfoOpen"
    [title]="'What can Swahib do for you?'"
    [maxWidth]="'480px'"
    [showCloseButton]="true"
    (closed)="closeConciergeInfo()">
    <div class="gs-concierge-modal-body">
      <div class="gs-concierge-modal-item">
        <div class="gs-concierge-modal-item-icon-box">
          <img src="assets/svg/chatbubble-ellipses-outline.svg" class="gs-concierge-modal-item-icon" alt="" />
        </div>
        <div class="gs-concierge-modal-item-text">
          <span class="gs-concierge-modal-item-title">Account consultation</span>
          <span class="gs-concierge-modal-item-desc">Schedule a call to get an in-depth review of your account.</span>
        </div>
      </div>
      <div class="gs-concierge-modal-item">
        <div class="gs-concierge-modal-item-icon-box">
          <img src="assets/svg/compass-outline.svg" class="gs-concierge-modal-item-icon" alt="" />
        </div>
        <div class="gs-concierge-modal-item-text">
          <span class="gs-concierge-modal-item-title">Personalized guidance</span>
          <span class="gs-concierge-modal-item-desc">Ask about how to optimize your property operations and maximize efficiency.</span>
        </div>
      </div>
      <div class="gs-concierge-modal-item">
        <div class="gs-concierge-modal-item-icon-box">
          <img src="assets/svg/shield-checkmark-outline.svg" class="gs-concierge-modal-item-icon" alt="" />
        </div>
        <div class="gs-concierge-modal-item-text">
          <span class="gs-concierge-modal-item-title">Security recommendations</span>
          <span class="gs-concierge-modal-item-desc">Reach out to see how you can improve your account security.</span>
        </div>
      </div>
    </div>
  </tidy-popup-overlay>

</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [isfullWidthContent]="true" [templateContent]="content" />
}
@if (windowService?.isDesktopRes) {
  <ion-content class="ion-content-right-column" [scrollY]="false">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
